var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-input',{attrs:{"name":_vm.data.slug,"slug":_vm.data.slug,"label":_vm.data.label,"value":_vm.data.value,"placeholder":_vm.$t('frontend-common.search')}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e421a3ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/cinquanta3/extensions/rubinred/catalog/assets/js/components/CatalogSearchFilter.vue
// module id = 8Hbu
// module chunks = 0